import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "magnifying-glass-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 1.5, transform: "translate(5 5)" },
        React.createElement("circle", { cx: 6, cy: 6, r: 5.25 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m13.25 13.25-3-3" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
